module.exports = __webpack_public_path__ + "static/img/码上用券@4x.952feea4.png";